import React, { useEffect } from 'react';
import { Tab } from 'components/molecules/Tab';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Path } from 'routes';
import './index.module.scss';
import { useTranslation } from 'react-i18next';
import style from './index.module.scss';
import { getWasteUnitsByOperatorId } from 'apis/operator_site/siteApi';
import { DEFAULT_PAGE } from 'util/ConstantValues';

interface Props {
  children?: React.ReactNode;
  itemCount?: number;
}

const OperatorManagementTemplate = ({ children, itemCount }: Props) => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { operatorId } = useParams<{ operatorId: string }>();

  const [fallbackItemCount, setFallbackItemCount] = React.useState(0);
  const displayItemCount = itemCount ?? fallbackItemCount;

  const tabItems = [
    t('site_management.tab_name'),
    <>
      {t('setting_operator_name.tab_name')}

      {displayItemCount > 0 && (
        <span className={style.badge}>{displayItemCount}</span>
      )}
    </>,
  ];
  const tabRoutes = [
    Path.adminOperatorManagementDetail.replace(':operatorId', operatorId),
    Path.adminOperatorItems.replace(':operatorId', operatorId),
  ];

  const defaultTabIndex = location.pathname.includes('/items') ? 1 : 0;

  useEffect(() => {
    if (typeof itemCount === 'number') {
      return;
    }

    getWasteUnitsByOperatorId({
      operatorId,
      query: {
        siteId: '',
        keyword: '',
        page: DEFAULT_PAGE,
        take: 1,
      },
      successCallback: (data) => {
        if (data) {
          setFallbackItemCount(data.wasteUnitWithoutOperatorItemCount);
        }
      },
    });
  }, [operatorId, itemCount]);

  return (
    <Tab
      tabMenuClassName={style.tabsMenu}
      withHash={false}
      tabItems={tabItems}
      defaultTabIndex={defaultTabIndex}
      setTabIndex={(tabIndex) => {
        history.push(`${tabRoutes[tabIndex]}${location.search}`);
      }}
      renderContent={({ index }) => {
        if (index !== defaultTabIndex) {
          return null;
        }

        return children;
      }}
    />
  );
};

export default OperatorManagementTemplate;
